import { CustomTooltip } from "@/components/CustomTooltip";
import { USER_RESPONSIBLE_PERMISSIONS } from "@/constants/User";
import { InfoOutlined } from "@mui/icons-material";
import { Box, Grid2, Link, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

export function OrganizationDefinition() {
	return (
		<>
			<Typography variant='body2'>
				Uma organização é uma entidade jurídica que pode representar uma
				empresa, instituição, ONG, etc. Ela deve ter um{" "}
				<Link
					href={
						"https://www.contabilizei.com.br/contabilidade-online/o-que-e-cnpj/"
					}
					target='_blank'
					rel='noopener noreferrer'
				>
					CNPJ válido
				</Link>{" "}
				e único para que possa ser utilizada na plataforma.
			</Typography>

			<Typography variant='body2'>
				Os usuários vinculados à organização não podem ter emails repetidos e
				deve haver pelo menos um usuário atribuído como responsável
				(administrador).
			</Typography>

			<Box
				sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}
			>
				<Typography variant='body2'>
					Uma organização é composta pelas seguintes propriedades:
				</Typography>

				<Grid2 container>
					<Grid2 size={6}>
						<ul
							style={{
								margin: 0,
								paddingLeft: "1.5rem",
								paddingTop: "0.25rem",
								display: "flex",
								flexDirection: "column",
								gap: 6,
							}}
						>
							<li>
								<Typography variant='body2'>CNPJ</Typography>
							</li>
							<li>
								<Typography variant='body2'>Nome</Typography>
							</li>
							<li>
								<Typography variant='body2'>CEP</Typography>
							</li>
							<li>
								<Typography variant='body2'>Usuários</Typography>
								<Typography
									variant='subtitle2'
									fontSize={"0.75rem"}
									color={blueGrey[500]}
								>
									Lista de pessoal credenciado
								</Typography>
								<ul
									style={{
										margin: 0,
										paddingLeft: "1.5rem",
										paddingTop: "0.25rem",
										display: "flex",
										flexDirection: "column",
										gap: 3,
									}}
								>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Primeiro nome
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Sobrenome
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Email
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Cargo
										</Typography>
									</li>
									<li>
										<Box
											sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}
										>
											<Typography variant='body2' fontSize={"0.8rem"}>
												Responsável
											</Typography>

											<CustomTooltip
												placement='top-end'
												offsetX={0}
												offsetY={-14}
												title={
													<Box maxWidth={260}>
														<Typography variant='body2' fontSize={"0.8rem"}>
															Confere permissões de administrador na
															organização:
														</Typography>
														<ul
															style={{
																margin: 0,
																paddingLeft: "1.5rem",
																paddingTop: "0.25rem",
																display: "flex",
																flexDirection: "column",
																gap: 4,
															}}
														>
															{USER_RESPONSIBLE_PERMISSIONS.map(
																(permission) => (
																	<li>
																		<Typography
																			variant='body2'
																			fontSize={"0.8rem"}
																		>
																			{permission}
																		</Typography>
																	</li>
																)
															)}
														</ul>
													</Box>
												}
											>
												<InfoOutlined
													sx={{
														color: blueGrey[600],
														width: "1rem",
														height: "1rem",
													}}
													fontSize='small'
												/>
											</CustomTooltip>
										</Box>
									</li>
								</ul>
							</li>
						</ul>
					</Grid2>
					<Grid2 size={6}>
						<ul
							style={{
								margin: 0,
								paddingLeft: "1.5rem",
								paddingTop: "0.25rem",
								display: "flex",
								flexDirection: "column",
								gap: 6,
							}}
						>
							<li>
								<Typography variant='body2'>Endereço</Typography>
							</li>
							<li>
								<Typography variant='body2'>Cidade</Typography>
							</li>
							<li>
								<Typography variant='body2'>Estado</Typography>
							</li>
							<li>
								<Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
									<Typography variant='body2'>Aplicações</Typography>

									<CustomTooltip
										placement='bottom-end'
										offsetX={0}
										offsetY={-14}
										title={
											<Typography
												variant='body2'
												fontSize={"0.8rem"}
												maxWidth={240}
											>
												Para mais detalhes sobre as aplicações, veja o guia
												rápido de definição
											</Typography>
										}
									>
										<InfoOutlined
											sx={{
												color: blueGrey[600],
												width: "1rem",
												height: "1rem",
											}}
											fontSize='small'
										/>
									</CustomTooltip>
								</Box>
								<Typography
									variant='subtitle2'
									fontSize={"0.75rem"}
									color={blueGrey[500]}
								>
									Soluções / Ferramentas da organização
								</Typography>
								<ul
									style={{
										margin: 0,
										paddingLeft: "1.5rem",
										paddingTop: "0.25rem",
										display: "flex",
										flexDirection: "column",
										gap: 3,
									}}
								>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Nome
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Descrição
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Área
										</Typography>
									</li>
									<li>
										<Typography variant='body2' fontSize={"0.8rem"}>
											Público
										</Typography>
									</li>
									<li>
										<Box
											sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}
										>
											<Typography variant='body2' fontSize={"0.8rem"}>
												Questionários
											</Typography>

											<CustomTooltip
												placement='bottom-end'
												offsetX={0}
												offsetY={-14}
												title={
													<Typography
														variant='body2'
														fontSize={"0.8rem"}
														maxWidth={240}
													>
														A aplicação é vinculada a questionários AIAs e
														questionário EPS
													</Typography>
												}
											>
												<InfoOutlined
													sx={{
														color: blueGrey[600],
														width: "1rem",
														height: "1rem",
													}}
													fontSize='small'
												/>
											</CustomTooltip>
										</Box>
									</li>
								</ul>
							</li>
						</ul>
					</Grid2>
				</Grid2>
			</Box>
		</>
	);
}
